<template>
  <ul class="commandAreaListWrap">
    <li v-for="(v,i) in listData"
      :key="i"
      @click="changeBtn(v,i)">
      <!-- <div class="imgBox"> -->
      <!-- <img :src="require('@/assets/images/msgt/area/' + activeItme==i?'a'+v.key:v.key + '.png')" /> -->
      <img :src="require(`@/assets/images/msgt/area/${activeItme==i?('a'+v.key):v.key}.png`)" />
      <!-- </div> -->
      <p>{{v.name}}</p>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      listData: [
        {
          name: "医院",
          key: "hospital",
          mapData: [
            { name: "洪雅县人民医院", value: [103.38683, 29.90678] },
            { name: "丹棱县人民医院", value: [103.523512, 30.019485] },
            { name: "眉山市人民医院", value: [103.856035, 30.067106] },
            { name: "彭山区人民医院", value: [103.872783, 30.208824] },
            { name: "仁寿县人民医院", value: [104.164976, 30.024082] },
            { name: "青神县人民医院", value: [103.84949, 29.83502] },
          ],
        },
        {
          name: "学校",
          key: "school",
          mapData: [
            { name: "洪雅中学", value: [103.388878, 29.906984] },
            { name: "丹棱中学", value: [103.522722, 30.028081] },
            { name: "东坡中学", value: [103.845819, 30.075507] },
            { name: "彭山区第三中学", value: [103.88203, 30.20492] },
            { name: "仁寿中学", value: [104.141481, 29.999383] },
            { name: "青神中学校", value: [103.859587, 29.850201] },
          ],
        },
        {
          name: "党政机关",
          key: "government",
          mapData: [
            { name: "洪雅县人民政府", value: [103.371732, 29.921636] },
            { name: "丹棱县人民政府", value: [103.519435, 30.021192] },
            { name: "东坡区人民政府", value: [103.838383, 30.048353] },
            { name: "彭山区人民政府", value: [103.879421, 30.19897] },
            { name: "仁寿县人民政府", value: [104.140575, 30.001664] },
            { name: "青神县人民政府", value: [103.852912, 29.837784] },
          ],
        },
        {
          name: "国营企业",
          key: "stateRun",
          mapData: [
            { name: "洪雅县供电分公司", value: [103.380287, 29.913729] },
            { name: "丹棱县供排水公司", value: [103.519838, 30.023425] },
            {
              name: "东坡区益民供排水有限公司",
              value: [103.874381, 30.037433],
            },
            {
              name: "中国电信(彭山区分公司)",
              value: [103.879704, 30.208018],
            },
            {
              name: "国网仁寿县供电公司",
              value: [104.15148, 29.991861],
            },
            {
              name: "青神县供电公司",
              value: [103.85699, 29.841415],
            },
          ],
        },
        {
          name: "行政机关",
          key: "organization",
          mapData: [
            { name: "洪雅县市民服务中心", value: [103.366075, 29.922309] },
            { name: "丹棱县市民服务中心", value: [103.516376, 30.018515] },
            { name: "东坡区市民服务中心", value: [103.907631, 30.071608] },
            { name: "彭山区市民服务中心", value: [103.871459, 30.202701] },
            { name: "仁寿县市民服务中心", value: [104.163858, 30.007738] },
            { name: "青神县市民服务中心", value: [103.844674, 29.844188] },
          ],
        },
        {
          name: "民营企业",
          key: "private",
          mapData: [
            {
              name: "洪雅县幺麻子食品有限公司",
              value: [103.339628, 29.897005],
            },
            {
              name: "丹棱县杰威家具有限公司",
              value: [103.543185, 30.026161],
            },
            {
              name: "台厨公司",
              value: [103.824681, 30.077326],
            },
            {
              name: "联合利华(四川)有限公司",
              value: [103.854725, 30.299084],
            },
            {
              name: "鑫统领建材科技公司",
              value: [103.994376, 30.019559],
            },
            {
              name: "青神县明瑞食品有限公司",
              value: [103.903286, 29.828171],
            },
          ],
        },
        {
          name: "综合商业",
          key: "business",
          mapData: [
            { name: "洪雅广场", value: [103.372222, 29.911692] },
            { name: "丹棱县永利家电商场", value: [103.51272, 30.017136] },
            { name: "宏远盖丽广场", value: [103.857776, 30.054591] },
            { name: "华兴购物超市(彭山店)", value: [103.869802, 30.195186] },
            { name: "美家好百货", value: [104.152308, 30.00075] },
            { name: "青神万景国际购物中心", value: [103.857731, 29.842494] },
          ],
        },
      ],
      activeItme: 0,
    };
  },
  methods: {
    changeBtn(v, i) {
      this.activeItme = i;
      this.$bus.$emit("getCommandMap", v.mapData);
    },
  },
  created() {
    this.$nextTick(() => {
      this.$bus.$emit("getCommandMap", this.listData[this.activeItme].mapData);
    });
  },
};
</script>

<style lang="scss" scoped>
.commandAreaListWrap {
  width: 100%;
  height: 85%;
  background: url("~@/assets/images/msgt/bottomBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  @include setFlexAround;
  li {
    width: 12%;
    height: 90%;
    @include setFlexColumn;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    img {
      width: 75%;
      height: 70%;
    }
    p {
      color: #fff;
    }
  }
}
</style>